import { render, staticRenderFns } from "./ImageForm.vue?vue&type=template&id=32f3543d&scoped=true&"
import script from "./ImageForm.vue?vue&type=script&lang=js&"
export * from "./ImageForm.vue?vue&type=script&lang=js&"
import style0 from "./ImageForm.vue?vue&type=style&index=0&id=32f3543d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f3543d",
  null
  
)

export default component.exports